import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import {DropdownSearchInput, TextSearchInput, TypeaheadSearchInput} from "../search-input.model";
import { SourceResolved } from '../search-input-source-resolver/source-resolver.service';

@Component({
  selector: 'asax-header-search-input-info',
  templateUrl: './search-input-info.component.html',
  styleUrls: ['./search-input-info.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SearchInputInfoComponent {
  @Input() searchInput: TextSearchInput | DropdownSearchInput | TypeaheadSearchInput;
  @Input() sourceResolved: SourceResolved;

  @Output() outExampleClick = new EventEmitter<string>();

  emitExample(example: string): void {
    this.outExampleClick.emit(example);
  }

}
